import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27a17026"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-2xl font-bold md:text-3xl" }, " তোমার মতামত শেয়ার করো ", -1))
const _hoisted_2 = { class: "mt-2" }
const _hoisted_3 = {
  key: 0,
  class: "loading loading-spinner"
}
const _hoisted_4 = {
  key: 0,
  class: "loading loading-spinner"
}

import axios from 'axios';
import type {
  SendContactMailDto,
  SendUserContactMailDto,
} from 'dto';
import type {
  SubmissionContext,
} from 'vee-validate';
import {
  Form,
} from 'vee-validate';
import {
  computed,
  ref,
} from 'vue';
import {
  useRoute,
} from 'vue-router';
import {
  object,
  string,
} from 'yup';
import Bus, {
  NOTIFICATION,
} from '@/bus';
import CustomButton1 from '@/components/Helper/Button/CustomButton1.vue';
import InputHelper from '@/components/Helper/InputHelper.vue';
import TextAreaHelper from '@/components/Helper/TextAreaHelper.vue';
import {
  CONSTANTS,
  handleAxiosError,
} from '@/helpers';
import {
  useStore,
} from '@/store';

interface IFormSubmitValues {
  email: string;
  message: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FeedbackForm',
  setup(__props) {


const feedbackSubmitBtn = computed(() => useStore.app.viewConfig.landingPage.feedbackSubmitBtn);
const isPublicHome = computed(() => useRoute().name === CONSTANTS.ROUTE.home.title);

const schema = object().shape({
  email: string()
    .label('ইমেইল')
    .email('অবশ্যই একটি বৈধ ইমেইল হতে হবে')
    .required(({ label }) => `${label} আবশ্যক`),

  message: string()
    .label('তোমার মতামত')
    .min(50, 'তোমার মতামত কমপক্ষে ৫০ অক্ষরের হতে হবে'),
});

const isSubmitting = ref(false);

async function onSubmit(
  values: IFormSubmitValues,
  submissionContext: SubmissionContext,
): Promise<void> {
  try {
    isSubmitting.value = true;

    const {
      email,
      message,
    } = values;

    const { user } = useStore.auth;
    const finalMessage = message.replace(/(?:\r\n|\r|\n)/g, '<br>');

    const payload: SendContactMailDto | SendUserContactMailDto = user ? {
      subject: 'Feedback from home',
      name: `${user.firstName} ${user.lastName}`,
      message: finalMessage,
      email: user.username,
      company: user.company,
      website: window.location.origin,
    } : {
      name: 'Public User',
      email,
      message: finalMessage,
      website: window.location.origin,
    };

    const url = `${user ? '' : '/public'}/emails/contact`;

    const response = await axios.post<{ message: string }>(
      url,
      payload,
    );

    Bus.emit(
      NOTIFICATION.SUCCESS,
      {
        message: response.data.message,
      },
    );

    submissionContext.resetForm();
  } catch (e: any) {
    handleAxiosError(e);
  } finally {
    isSubmitting.value = false;
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "feedback-section",
    class: _normalizeClass(["flex w-full flex-col rounded-lg bg-dynamicInfoBg px-3 py-6 xs:px-7", isPublicHome.value ? 'box-shadow text-dynamicInfoText' : 'bg-white'])
  }, [
    _hoisted_1,
    _createVNode(_unref(Form), {
      class: "mt-2",
      validationSchema: _unref(schema),
      onSubmit: onSubmit
    }, {
      default: _withCtx(({ isSubmitting: isValidatingForm }) => [
        _createVNode(InputHelper, {
          required: "",
          name: "email",
          type: "email",
          label: "ইমেইল",
          placeholder: "তোমার ইমেইল এড্রেস",
          successMessage: "ধন্যবাদ"
        }),
        _createVNode(TextAreaHelper, {
          required: "",
          name: "message",
          type: "text",
          label: "তোমার মতামত",
          placeholder: "তোমার মতামত দাও",
          successMessage: "ধন্যবাদ",
          rows: 3
        }),
        _createElementVNode("div", _hoisted_2, [
          (feedbackSubmitBtn.value.theme === 1)
            ? (_openBlock(), _createBlock(CustomButton1, {
                key: 0,
                content: "মতামত পাঠাও",
                disabled: isSubmitting.value || isValidatingForm,
                type: "submit",
                class: "ml-0 max-w-[192px]"
              }, {
                default: _withCtx(() => [
                  (isSubmitting.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_3))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["disabled"]))
            : (feedbackSubmitBtn.value.theme === 2)
              ? (_openBlock(), _createBlock(CustomButton1, {
                  key: 1,
                  content: "Send",
                  disabled: isSubmitting.value || isValidatingForm,
                  type: "submit",
                  class: "ml-0 max-w-[192px]",
                  category: "category-5"
                }, {
                  default: _withCtx(() => [
                    (isSubmitting.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_4))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["disabled"]))
              : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["validationSchema"])
  ], 2))
}
}

})